var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('hr'),_c('br'),_c('order-form',{ref:"orderForm",attrs:{"id":this.$route.params.id,"operation":2}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('h2',{staticClass:"text-primary",staticStyle:{"margin-bottom":"0px"}},[_c('i',{staticClass:"fas fa-shopping-cart"}),_vm._v(" Devolução\n      ")])])])
}]

export { render, staticRenderFns }